<template>
  <div id="NewsPage">
    <div class="header">
      <h2>
        <b>{{ news_data.category }}</b>
        <span>{{ news_data.title }}</span>
      </h2>
      <p>{{ news_data.create_time.slice(0, 10) }}</p>
    </div>

    <div class="social_box">
      <button @click="ShareToLine">LINE 分享</button>
      <button @click="ShareToFB">Facebook 分享</button>
    </div>

    <div class="content" v-html="news_data.description"></div>

    <div class="footer">
      <button @click="$router.push('/news/list/1')" class="back_button">
        回到最新消息列表
      </button>
    </div>
  </div>
</template>

<script>
import qs from "qs"
export default {
  name: "NewsList",
  data() {
    return {
      news_data: null
    }
  },
  methods: {
    ShareToFB() {
      window.open(`https://www.facebook.com/sharer.php?u=${window.location.href}`, '_blank').focus();
    },
    ShareToLine() {
      window.open(`line://msg/text/${window.location.href}`, '_blank').focus();
    },
    async GetNewsoData() {
      let result = await this.SendPostData(process.env.VUE_APP_BASE_API + 'news/get_news.php', qs.stringify({ id: this.$route.params.id }))
      if (result != "error") {
        console.log()
        this.news_data = JSON.parse(result.data)
      }
    }
  },
  created() {
    this.GetNewsoData()
  },
}
</script>